var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDelete = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33337 3.99992C1.33337 3.63173 1.63185 3.33325 2.00004 3.33325H14C14.3682 3.33325 14.6667 3.63173 14.6667 3.99992C14.6667 4.36811 14.3682 4.66659 14 4.66659H2.00004C1.63185 4.66659 1.33337 4.36811 1.33337 3.99992Z",
    fill: "#60666E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66663 2.00008C6.48981 2.00008 6.32025 2.07032 6.19522 2.19534C6.0702 2.32037 5.99996 2.48994 5.99996 2.66675V3.33341H9.99996V2.66675C9.99996 2.48994 9.92972 2.32037 9.8047 2.19534C9.67967 2.07032 9.5101 2.00008 9.33329 2.00008H6.66663ZM11.3333 3.33341V2.66675C11.3333 2.13631 11.1226 1.62761 10.7475 1.25253C10.3724 0.877462 9.86373 0.666748 9.33329 0.666748H6.66663C6.13619 0.666748 5.62749 0.877462 5.25241 1.25253C4.87734 1.62761 4.66663 2.13631 4.66663 2.66675V3.33341H3.33329C2.9651 3.33341 2.66663 3.63189 2.66663 4.00008V13.3334C2.66663 13.8638 2.87734 14.3726 3.25241 14.7476C3.62748 15.1227 4.13619 15.3334 4.66663 15.3334H11.3333C11.8637 15.3334 12.3724 15.1227 12.7475 14.7476C13.1226 14.3726 13.3333 13.8638 13.3333 13.3334V4.00008C13.3333 3.63189 13.0348 3.33341 12.6666 3.33341H11.3333ZM3.99996 4.66675V13.3334C3.99996 13.5102 4.0702 13.6798 4.19522 13.8048C4.32025 13.9298 4.48982 14.0001 4.66663 14.0001H11.3333C11.5101 14.0001 11.6797 13.9298 11.8047 13.8048C11.9297 13.6798 12 13.5102 12 13.3334V4.66675H3.99996Z",
    fill: "#60666E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDelete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delete.ae4bcaec0787ddb832cfc55383af9822.svg";